<template>
    <div
        id="be-addsearch-project"
        class="bg-light"
    >
        <div class="body-wrapper">

            <main class="pt-0 mt-0">

                <backend-gallery-header
                    :eventId="eventId"
                    :gallery="gallery"
                    hide-btn-share
                    hide-btn-preview
                    hide-btn-agents
                    @back="goBackToGallery"
                />

                <div class="barra-filtri">
                    <div class="container-fluid">
                        <div class="row align-items-center">
                            <div class="col-12 col-lg-3 py-3 py-md-0">
                                <p class="mb-0 text-uppercase font-titoli-rikorda text-blurikorda">Cerca progetto</p>
                            </div>
                            <div class="col-12 col-lg-9 mt-0 mt-md-2 mt-lg-0">
                                <div class="filtri d-flex align-items-center flex-wrap">
                                    <p class="mb-0 text-uppercase font-titoli-rikorda text-blurikorda">
                                        <span class="d-none d-md-inline">Filtra</span>
                                        <a
                                            class="d-inline d-md-none"
                                            href="#"
                                            @click.prevent="onFilterLabelClicked"
                                        >Filtra
                                            <font-awesome-icon
                                                v-if="filterLabelOpen"
                                                :icon="['fa', 'chevron-down']"
                                            />
                                            <font-awesome-icon
                                                v-else
                                                :icon="['fa', 'chevron-right']"
                                            />
                                        </a>
                                    </p>
                                    <b-dropdown
                                        right
                                        variant="light border"
                                        class="input-filtro"
                                        :class="{'filtri-aperti': filterLabelOpen}"
                                        ref="filterProjectsByType"
                                    >
                                        <template v-slot:button-content>
                                            {{ projectTypes[searchFilters.category] }}
                                        </template>
                                        <b-dropdown-item
                                            v-for="(value, key) in projectTypes"
                                            :key="key"
                                            @click="filterProjectsByType(key)"
                                        >
                                            {{value}}
                                            <font-awesome-icon
                                                :icon="['fa', 'check']"
                                                v-if="searchFilters.category==key"
                                            />
                                        </b-dropdown-item>
                                    </b-dropdown>

                                    <b-dropdown
                                        right
                                        variant="light border"
                                        class="input-filtro"
                                        :class="{'filtri-aperti': filterLabelOpen}"
                                        ref="filterProjectsBySort"
                                    >
                                        <template v-slot:button-content>
                                            {{ sortTypes[searchFilters.sortField] }}
                                        </template>
                                        <b-dropdown-item @click="filterProjectsBySort('Datacreazione')">
                                            {{ sortTypes['Datacreazione'] }}
                                            <font-awesome-icon
                                                :icon="['fa', 'check']"
                                                v-if="(searchFilters.sortField=='Datacreazione')"
                                            />
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="filterProjectsBySort('Titolo')">
                                            {{ sortTypes['Titolo'] }}
                                            <font-awesome-icon
                                                :icon="['fa', 'check']"
                                                v-if="(searchFilters.sortField=='Titolo')"
                                            />
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="filterProjectsBySort('Datascadenza')">
                                            {{ sortTypes['Datascadenza'] }}
                                            <font-awesome-icon
                                                :icon="['fa', 'check']"
                                                v-if="(searchFilters.sortField=='Datascadenza')"
                                            />
                                        </b-dropdown-item>
                                    </b-dropdown>

                                    <b-input-group
                                        size="sm"
                                        class="input-cerca-progetti input-filtro"
                                        :class="{'filtri-aperti': filterLabelOpen}"
                                        ref="filterProjectsByText"
                                    >
                                        <b-form-input
                                            type="search"
                                            placeholder="Cerca per nome progetto"
                                            class="rounded-pill rilievo-ombra-interna"
                                            v-model="searchFilters.text"
                                            @change="filterProjectsByText"
                                            @keyup.enter="filterProjectsByText"
                                        >
                                        </b-form-input>
                                        <font-awesome-icon :icon="['fas', 'search']" />
                                    </b-input-group>

                                    <button
                                        type="button"
                                        class="pulsante-annulla btn btn-rikorda2-alt"
                                        @click="goBackToGallery"
                                    >
                                        {{ $t("Annulla") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="col-12 col-xl-10 offset-xl-1">
                        <ul class="griglia-progetti d-flex justify-content-start flex-wrap">
                            <li
                                class="progetto-wrapper col-12 col-md-6 mt-3"
                                v-for="(project, i) in projects"
                                :key="'project-'+i"
                            >
                                <gallery-project
                                    :eventId="eventId"
                                    :project="project"
                                    :mode="'share'"
                                    @share="shareProject(project)"
                                />
                            </li>
                        </ul>

                        <div class="mt-3 text-center">
                            <a
                                href="#"
                                v-show="showMore"
                                @click.prevent="showMoreProjects()"
                            >{{ $t('Mostra altri progetti') }}</a>
                        </div>
                    </div>
                </div>
            </main>

            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendGalleryHeader from "../../components/backend/GalleryHeader";
import BackendFooter from "../../components/backend/Footer";
import GalleryProject from "../../components/backend/GalleryProject";
import naturalCompare from "natural-compare-lite";
import moment from "moment";

export default {
    name: "BackendSearchProjects",

    components: {
        BackendGalleryHeader,
        BackendFooter,
        GalleryProject
    },

    data() {
        return {
            eventId: "",

            gallery: {},

            searchFilters: {
                eventId: "",
                page: 0,
                category: "all",
                sortField: "Datacreazione",
                text: ""
            },

            searchResult: {},
            showMore: true,

            projects: [],
            //filteredProjects: [],

            projectTypes: {
                all: "Visualizza Tutti",
                book: "Fotolibri",
                fotoarredo: "Arredo",
                "Idee Regalo": "Idee Regalo",
                "Biglietti e Cartoline": "Biglietti e Cartoline",
                Fotocalendari: "Calendari"
            },

            sortTypes: {
                Datacreazione: "Data di creazione",
                Titolo: "Nome",
                Datascadenza: "Data di scadenza"
            },

            filterLabelOpen: false
        };
    },

    mounted() {
        this.eventId = this.$route.params.eventId;

        this.searchFilters.eventId = this.eventId;

        this.$api
            .backendGetGalleryData(this.eventId)
            .then((response) => {
                console.log("BACKEND_GET_GALLERY_DATA", response);

                if (response.gallery) {
                    this.gallery = response.gallery;
                }
            })
            .catch((error) => {
                console.error("BACKEND_GET_GALLERY_DATA", error);
            });

        this.showMoreProjects();
    },

    methods: {
        goBackToGallery() {
            this.$router.push({
                name: "backend-gallery",
                params: { eventId: this.eventId, activeTab: "projects" }
            });
        },

        shareProject(project) {
            this.$router.push({
                name: "backend-gallery-share-project",
                params: {
                    eventId: this.eventId,
                    projectId: project.idProgetto,
                    project: project,
                    mode: "share", // nuova condivisione
                    gallery: this.gallery
                }
            });
        },

        showMoreProjects() {
            this.searchFilters.page++;

            this.$api
                .backendGetShareableProjects(this.searchFilters)
                .then((response) => {
                    console.log("BACKEND_GET_SHAREABLE_PROJECTS", response);
                    this.searchResult = response.result;

                    this.showMore = response.result.paginazioneNecessaria;

                    if (this.searchFilters.page == 1) {
                        this.projects = response.result.lista;
                    } else {
                        this.projects.push(...response.result.lista);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        filterProjectsByType(projectType) {
            this.searchFilters.category = projectType;
            this.searchFilters.page = 0;
            this.showMoreProjects();
        },

        filterProjectsByText() {
            this.searchFilters.page = 0;
            this.showMoreProjects();
        },

        filterProjectsBySort(sortField) {
            this.searchFilters.sortField = sortField;
            this.searchFilters.page = 0;
            this.showMoreProjects();
        },

        onFilterLabelClicked() {
            this.filterLabelOpen = !this.filterLabelOpen;
        }
    }
};
</script>

<style>
</style>
